import { ApiActionTypes, buildApiTypeAction } from "../apiLoader/apiLoaderUtils";

const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPANY_API = buildApiTypeAction(GET_COMPANY, ApiActionTypes.REQUEST);
export const GET_COMPANY_API_SUCCESS = buildApiTypeAction(GET_COMPANY, ApiActionTypes.SUCCESS);
export const GET_COMPANY_API_ERROR = buildApiTypeAction(GET_COMPANY, ApiActionTypes.ERROR);

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';

const UPDATE_COMPANY_DATA = 'UPDATE_COMPANY_DATA';
export const UPDATE_COMPANY_DATA_API = buildApiTypeAction(UPDATE_COMPANY_DATA, ApiActionTypes.REQUEST);
export const UPDATE_COMPANY_DATA_API_SUCCESS = buildApiTypeAction(UPDATE_COMPANY_DATA, ApiActionTypes.SUCCESS);
export const UPDATE_COMPANY_DATA_API_ERROR = buildApiTypeAction(UPDATE_COMPANY_DATA, ApiActionTypes.ERROR);

const GET_ACTIVITY_LOG_RECORDS = 'GET_ACTIVITY_LOG_RECORDS';
export const GET_ACTIVITY_LOG_RECORDS_API = buildApiTypeAction(GET_ACTIVITY_LOG_RECORDS, ApiActionTypes.REQUEST);
export const GET_ACTIVITY_LOG_RECORDS_API_SUCCESS = buildApiTypeAction(GET_ACTIVITY_LOG_RECORDS, ApiActionTypes.SUCCESS);
export const GET_ACTIVITY_LOG_RECORDS_API_ERROR = buildApiTypeAction(GET_ACTIVITY_LOG_RECORDS, ApiActionTypes.ERROR);